import { render, staticRenderFns } from "./ViewHeader.vue?vue&type=template&id=166dbb69"
import script from "./ViewHeader.ts?vue&type=script&lang=ts&external"
export * from "./ViewHeader.ts?vue&type=script&lang=ts&external"
import style0 from "./ViewHeader.vue?vue&type=style&index=0&id=166dbb69&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports